import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 27 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 14.3438,
			y: 14.3438,
			width: 8.4375,
			height: 8.4375,
			fill: "#FEBA08"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4.21875,
			y: 14.3438,
			width: 8.4375,
			height: 8.4375,
			fill: "#05A6F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 14.3438,
			y: 4.21875,
			width: 8.4375,
			height: 8.4375,
			fill: "#80BC06"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4.21875,
			y: 4.21875,
			width: 8.4375,
			height: 8.4375,
			fill: "#F25325"
		})
	]
});
export default SvgMicrosoftLogo;
